export default __webpack_public_path__ + "static/media/updapt-esg-all-in-one.e16e801d.png";